import { z } from 'zod';

export const WriteBackToFountainMergeAuthMethod = z.object({
  type: z.literal('merge'),
  dataSetId: z.string().optional(),
});

export type WriteBackToFountainMergeAuthMethod = z.infer<
  typeof WriteBackToFountainMergeAuthMethod
>;

export const WriteBackToFountainConnectionMethod = z.object({
  type: z.literal('connection'),
});

export type WriteBackToFountainConnectionMethod = z.infer<
  typeof WriteBackToFountainConnectionMethod
>;

export const WriteBackToFountainAuthMethod = z.union([
  WriteBackToFountainMergeAuthMethod,
  WriteBackToFountainConnectionMethod,
]);

export type WriteBackToFountainAuthMethod = z.infer<
  typeof WriteBackToFountainAuthMethod
>;

export const WriteBackToFountainStageChangePlaceToWrite = z.object({
  type: z.literal('stageChange'),
});

export type WriteBackToFountainStageChangePlaceToWrite = z.infer<
  typeof WriteBackToFountainStageChangePlaceToWrite
>;

export const WriteBackToFountainCustomFieldPlaceToWrite = z.object({
  type: z.literal('customField'),
  customFieldKey: z.string(),
});

export type WriteBackToFountainCustomFieldPlaceToWrite = z.infer<
  typeof WriteBackToFountainCustomFieldPlaceToWrite
>;

export const WriteBackToFountainNotePlaceToWrite = z.object({
  type: z.literal('note'),
});

export type WriteBackToFountainNotePlaceToWrite = z.infer<
  typeof WriteBackToFountainNotePlaceToWrite
>;

export const WriteBackToFountainPlaceToWrite = z.union([
  WriteBackToFountainNotePlaceToWrite,
  WriteBackToFountainCustomFieldPlaceToWrite,
  WriteBackToFountainStageChangePlaceToWrite,
]);

export type WriteBackToFountainPlaceToWrite = z.infer<
  typeof WriteBackToFountainPlaceToWrite
>;

export const WriteBackToFountainStrategy = z.object({
  type: z.literal('fountain'),
  authMethod: WriteBackToFountainAuthMethod.optional(),
  placesToWrite: z.array(WriteBackToFountainPlaceToWrite).optional(),
});

export type WriteBackToFountainStrategy = z.infer<
  typeof WriteBackToFountainStrategy
>;
